import React, { useEffect , useState} from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { jwtDecode } from "jwt-decode";


  const pricesLinks = [{
    url:"/prices",
    title:"Prices"
  }]
  
  const lintCottonLinks = [
    {url:"/lintcotton", title:"Lint Cotton"},
    {url:"/uploadrates", title:"Upload Rates"}
  ]

  const cropSurveysLinks = [
    {url:"/cropcondition", title:"Crop Condition"},
    {url:"/sowing", title:"Sowing"},
    {url:"/agron", title:"Agron"},
    {url:"/intention", title:"Intention"},
    {url:"/images", title:"Images"},
  ]

  const impexLinks = [
    {url:"/import", title:"Import"},
    {url:"/export", title:"Export"},
  ]

  const KCALinks = [
    {url:"/KCA", title:"KCA"},
  ]

  const PCGALinks = [
    {url:"/PCGA", title:"PCGA"},
  ]

  const BSLinks = [
    {url:"/balance-sheet", title:"Balance Sheet"},
  ]

  const NBLinks = [
    {url:"/news", title:"News"},
    {url:"/blogs", title:"Blogs"},
  ]




const Tiles = ({name, links})=>{
  return(
    <div class="dropdown sidebar-dropdown">
  <button class="btn btn-secondary dropdown-toggle sidebar-button" type="button" data-bs-toggle="dropdown" aria-expanded="false">
    {name}
  </button>
  <ul class="dropdown-menu btn btn-secondary btn-lg mb-2 sidebar-ul">
  {links.map((link, index) => {
  return (
    <li key={index} className="sidebar-li">
      <Link to={link.url} className="sidebar-link">{link.title}</Link>
    </li>
  );
})}

  </ul>
</div>
  )
}
const Sidebar = () => {
  function isValidToken(token) {
    if (typeof token !== 'string') {
      // console.error('Invalid token specified: must be a string');
      return false;
    }
  
    const parts = token.split('.');
    if (parts.length !== 3) {
      // console.error('Invalid token specified: missing part #');
      return false;
    }
  
    try {
      const decodedPart = Buffer.from(parts[1], 'base64').toString('utf8');
      JSON.parse(decodedPart);
    } catch (error) {
      // console.error('Invalid token specified: ' + error.message);
      return false;
    }
  
    return true;
  }
  const [name, setName] = useState()
  const [role, setRole] = useState()

  const [expandedDropdowns, setExpandedDropdowns] = useState([]);

  const toggleDropdown = (index) => {
    if (expandedDropdowns.includes(index)) {
      setExpandedDropdowns(expandedDropdowns.filter(item => item !== index));
    } else {
      setExpandedDropdowns([...expandedDropdowns, index]);
    }
  };

  const isDropdownExpanded = (index) => {
    return expandedDropdowns.includes(index);
  };
  

  useEffect(()=>{
    const token = sessionStorage.getItem('token')

    const item = jwtDecode(token)
    setName(item.userName)
    setRole(item.role)
  },[])
  const nav = useNavigate()

  const handleLogout = ()=>{
      sessionStorage.clear()
      if(!sessionStorage.getItem('token')){
        nav('/login')
      }
  }
  return (

<div class="fixed-sidebar sidebar-tool">
  <div class="sidebar-header">
    <h5 class="sidebar-title">PAR ADMIN PANEL</h5>
    <div style={{color:"#6486EB"}}>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-circle" viewBox="0 0 16 16">
  <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
  <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
</svg> {name}
    </div>
  </div>
  {role === "blogger" ? (
    <div class="sidebar-body">
      <div class="dropdown sidebar-dropdown">
          <Link to="/blogs">
          <button class="btn btn-secondary  sidebar-button" type="button"  aria-expanded="false">      
            Blogs
          </button></Link>
      </div>
      <div className="log-out sidebar-logout">
        <button type="button" onClickCapture={handleLogout}  class="btn btn-light"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-power" viewBox="0 0 16 16" >
          <path d="M7.5 1v7h1V1h-1z"/>
          <path d="M3 8.812a4.999 4.999 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812z"/>                              
          
        </svg>                Log Out</button>  
        </div>
      </div>
  ) : (
    <div class="sidebar-body">
  <div class="dropdown sidebar-dropdown">
  <Link to="/">
  <button class="btn btn-secondary  sidebar-button" type="button"  aria-expanded="false">      
    Home
  </button></Link>
</div>
  <div class="accordion" id="accordionExample">
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
        Prices
      </button>
    </h2>
    <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
    <div class="accordion-body d-flex flex-column">
      <Link to="/prices"><button type="button" class="btn btn-light text-start fs-5"> <strong>Prices</strong> </button></Link>
      <Link to="/lintcotton"><button type="button" class="btn btn-light text-start fs-5"> <strong>Lint Cotton Prices</strong> </button></Link>
      <Link to="/sugar-mill-data"><button type="button" class="btn btn-light text-start fs-5"> <strong>Sugar Mill Data</strong> </button></Link>
      <Link to="/jodia-bazar"><button type="button" class="btn btn-light text-start fs-5"> <strong>Jodia Bazar</strong> </button></Link>
      <Link to="/akbari-mandi"><button type="button" class="btn btn-light text-start fs-5"> <strong>Akbari Mandi</strong> </button></Link>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
        Crop Surveys
      </button>
    </h2>
    <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
    <div class="accordion-body d-flex flex-column">
      <Link to="/cropcondition"><button type="button" class="btn btn-light text-start fs-5"> <strong>Crop Condition</strong> </button></Link>
      <Link to="/intention"><button type="button" class="btn btn-light text-start fs-5"> <strong>Intention</strong> </button></Link>
      <Link to="/sowing"><button type="button" class="btn btn-light text-start fs-5"> <strong>Sowing</strong> </button></Link>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
        News & Blogs
      </button>
    </h2>
    <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div class="accordion-body d-flex flex-column">
      <Link to="/news"><button type="button" class="btn btn-light text-start fs-5"> <strong>News</strong> </button></Link>
      <Link to="/blogs"><button type="button" class="btn btn-light text-start fs-5"> <strong>Blogs</strong> </button></Link>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
        SEO
      </button>
    </h2>
    <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div class="accordion-body d-flex flex-column">
      <Link to="/seo-pages"><button type="button" class="btn btn-light text-start fs-5"> <strong>Heading & Description</strong> </button></Link>
      </div>
    </div>
  </div>
</div>



{/* <Tiles name={"Prices"} links={pricesLinks}></Tiles>
<Tiles name={"Lint Cotton"} links={lintCottonLinks}></Tiles>
<Tiles name={"Crop Surveys"} links={cropSurveysLinks}></Tiles>
<Tiles name={"Impex Uploads"} links={impexLinks}></Tiles>
<Tiles name={"KCA Spot Rate"} links={KCALinks}></Tiles>
<Tiles name={"PCGA"} links={PCGALinks}></Tiles>
<Tiles name={"Balance Sheet"} links={BSLinks}></Tiles>
<Tiles name={"Media"} links={NBLinks}></Tiles> */}



<div className="log-out sidebar-logout">
<button type="button" onClickCapture={handleLogout}  class="btn btn-light"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-power" viewBox="0 0 16 16" >
  <path d="M7.5 1v7h1V1h-1z"/>
  <path d="M3 8.812a4.999 4.999 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812z"/>                              
  
</svg>                Log Out</button>  
</div>
    
  </div>
  )}
  
</div>

  )
}

export default Sidebar


